import React from "react"

export default function ({ children }){
    return (
        <h3 className="p-3 pergunta m-3">
            { children }
        </h3>
    )
}